import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { RestapiService } from '../services/restapi.service';
import amplitude from 'amplitude-js';

/*
Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Malekar
*/
@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.css']
})
export class HeaderNavComponent implements OnInit {

  public navMenu: boolean;
  public supportMenu: boolean;
  public salesMenu: boolean;
  public docMenu: boolean;

  public scaleCount: string = '';
  public feedBackDescription: string = '';
  public email: string = '';
  public contactPersmission: boolean = true;
  public  instance1 = amplitude.getInstance().init("ff1f348e52206af809b752482e39fb8e");

  public buttonArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  toggle: boolean = true;
  showScale: boolean = false;
  showDescription: boolean = false;
  showEmail: boolean = false;
  feedbackSubmitted: boolean = true;
  contactPerson = 'No';

  constructor(public googleAnalyticsService: GoogleAnalyticsService,
    private apiService: RestapiService) { }

  ngOnInit(): void {

  }



  toggleDropdown() {
    (document.getElementById('dropdownContainer') as HTMLInputElement).classList.toggle('dropdown--state-active');
    (document.getElementById('dropdownContainer1') as HTMLInputElement).classList.toggle('dropdown--state-active', false);
    (document.getElementById('dropdownContainer2') as HTMLInputElement).classList.toggle('dropdown--state-active', false);

  }
  toggleDropdown1() {
    (document.getElementById('dropdownContainer1') as HTMLInputElement).classList.toggle('dropdown--state-active');
    (document.getElementById('dropdownContainer') as HTMLInputElement).classList.toggle('dropdown--state-active', false);
    (document.getElementById('dropdownContainer2') as HTMLInputElement).classList.toggle('dropdown--state-active', false);

  }
  toggleDropdown2() {
    (document.getElementById('dropdownContainer2') as HTMLInputElement).classList.toggle('dropdown--state-active');
    (document.getElementById('dropdownContainer') as HTMLInputElement).classList.toggle('dropdown--state-active', false);
    (document.getElementById('dropdownContainer1') as HTMLInputElement).classList.toggle('dropdown--state-active', false);

  }
  focusOut() {
    (document.getElementById('dropdownContainer') as HTMLInputElement).classList.toggle('dropdown--state-active', false);
    (document.getElementById('dropdownContainer1') as HTMLInputElement).classList.toggle('dropdown--state-active', false);
    (document.getElementById('dropdownContainer2') as HTMLInputElement).classList.toggle('dropdown--state-active', false);

  }

  mobNav() {
    this.navMenu = !this.navMenu;
  }

  openSupport() {
    this.supportMenu = !this.supportMenu;
    this.docMenu = false;
    this.salesMenu = false;
  }

  openDocumentation() {
    this.docMenu = !this.docMenu;
    this.supportMenu = false;
    this.salesMenu = false;
  }

  openSales() {
    this.salesMenu = !this.salesMenu;
    this.docMenu = false;
    this.supportMenu = false;
  }

  openVDBSoftwareDownloads() {
    this.googleAnalyticsFunction('Resources', 'Menu', 'VDB Software Downloads', 'VDB Software Downloads', 1);
    amplitude.getInstance().logEvent("VDB Software Downloads",{    "Main Menu": "Resources" });
    window.open('https://software.cisco.com/download/home/286259687/type/286321931/release/VDB', '_blank');
  }
  openTalos() {
    this.googleAnalyticsFunction('Resources', 'Menu', 'Talos', 'Talos', 1);
      // initialize the client
   // var instance1 = amplitude.getInstance().init("ff1f348e52206af809b752482e39fb8e");
    amplitude.getInstance().logEvent("Talos",{    "Main Menu": "Resources" });
    window.open('https://talosintelligence.com/', '_blank');
  }
  openApplicationDetection() {
    this.googleAnalyticsFunction('Documentation', 'Menu', 'Application Detection', 'Application Detection', 1);
    amplitude.getInstance().logEvent("Application Detection",{    "Main Menu": "Documentation" });
    window.open('https://www.cisco.com/c/en/us/td/docs/security/firepower/70/configuration/guide/fpmc-config-guide-v70/application_detection.html?bookSearch=true', '_blank');
  }
  openOpenId() {
    this.googleAnalyticsFunction('Documentation', 'Menu', 'OpenAppID', 'OpenAppID', 1);
    amplitude.getInstance().logEvent("OpenAppID",{    "Main Menu": "Documentation" });
    window.open('https://snort.org/downloads#openappid', '_blank');
  }
  openYouTubeVideo() {
    this.googleAnalyticsFunction('Documentation', 'Menu', 'AppID Portal Intro VoD (8 min)', 'AppID Portal Intro VoD (8 min)', 1);
    amplitude.getInstance().logEvent("AppID Portal Intro VoD (8 min)",{    "Main Menu": "Documentation" });
    window.open('https://youtu.be/TYc9_lbkbVw', '_blank');
  }
  openEncryptedVisibilityDetails(){
    this.googleAnalyticsFunction('Documentation', 'Menu', 'Encrypted Visibility Details', 'Encrypted Visibility Details', 1);
    amplitude.getInstance().logEvent("Encrypted Visibility Details",{    "Main Menu": "Documentation" });
    window.open('https://secure.cisco.com/secure-firewall/v7.2/docs/encrypted-visibility-engine', '_blank');
  }

  openEncryptedVisibilityEngine(){
    this.googleAnalyticsFunction('Support', 'Menu', 'Encrypted Visibility Engine Support', 'Encrypted Visibility Engine Support', 1);
    amplitude.getInstance().logEvent("Encrypted Visibility Engine Support",{    "Main Menu": "Support" });
    window.location.href='/eve';
  }
  openProducts() {
    this.googleAnalyticsFunction('Resources', 'Menu', 'Solutions', 'Solutions', 1);
    amplitude.getInstance().logEvent("Solutions",{    "Main Menu": "Resources" });
    window.open('https://www.cisco.com/c/en/us/products/security/firewalls/index.html', '_blank');
  }
  openPartnerHelp() {
    this.googleAnalyticsFunction('Resources', 'Menu', 'Partner Help', 'Partner Help', 1);
    amplitude.getInstance().logEvent("Partner Help",{    "Main Menu": "Resources" });
    window.open('https://www.cisco.com/c/en/us/partners/support-help/presales-helpline.html', '_blank');
  }


  openYouTubeChannel() {
    this.googleAnalyticsFunction('Resources', 'Menu', 'YouTube Channel', 'YouTube Channel', 1);
    amplitude.getInstance().logEvent("YouTube Channel",{    "Main Menu": "Resources" });
    window.open('https://www.youtube.com/c/CiscoNetSec/videos', '_blank');
  }

  openDevNetPortal() {
    this.googleAnalyticsFunction('Resources', 'Menu', 'DevNet Portal', 'DevNet Portal', 1);
    amplitude.getInstance().logEvent("DevNet Portal",{    "Main Menu": "Resources" });
    window.open('https://developer.cisco.com/secure-firewall/', '_blank');
  }

  openTerraformRegistry() {
    this.googleAnalyticsFunction('Resources', 'Menu', 'Terraform Registry', 'Terraform Registry', 1);
    amplitude.getInstance().logEvent("Terraform Registry",{    "Main Menu": "Resources" });
    window.open('https://registry.terraform.io/search/providers?namespace=CiscoDevNet', '_blank');
  }

  openLevelUp() {
    this.googleAnalyticsFunction('Resources', 'Menu', 'Level Up', 'Level Up', 1);
    amplitude.getInstance().logEvent("Level Up",{    "Main Menu": "Resources" });
    window.open('https://cloud.path.cisco.com/secure-firewall-levelup', '_blank');
  }
 
  //evtName: string, evtCategory: string, evtAction: string, evtLabel: string, evtValue: number
  googleAnalyticsFunction(actionName: string, evtCategory: string, eventName: string, eventLabel: string, evtValue: number) {

    this.googleAnalyticsService.eventEmitter(
      actionName,      //eventName -> Partner Help
      evtCategory,       //evtCategory ->Menu
      eventName,    //evtAction -> Resources
      eventLabel, //evtLabel -> Partner Help
      evtValue,           //evtValue
    );
  }
  openModal(modalType) {
    this.resetValues();
    (document.getElementById(modalType) as HTMLInputElement).style.display = 'block';
    (document.getElementById('backdrop') as HTMLInputElement).style.display = 'block';
  }

  closeModal(modalType) {
    (document.getElementById(modalType) as HTMLInputElement).style.display = 'none';
    (document.getElementById('backdrop') as HTMLInputElement).style.display = 'none';
    this.resetValues();
  }
  submitFeedback() {
    console.log('submitFeedback : ');
   
    
    if (this.contactPersmission) {
      this.contactPerson = 'Yes'
    }

       
    if (this.scaleCount === '') {
      this.showScale = true;
      
    }else{
      this.showScale = false;
    }
    console.log('this.scaleCount  : '+ this.scaleCount );
    console.log('this.showScale  : '+ this.showScale );
    if (this.feedBackDescription === '' || this.feedBackDescription === ' ') {
      this.showDescription = true;
    }else{
      this.showDescription = false;
    }
    if (this.email === '' || this.email === ' ') {
      this.showEmail = true;
    }else{
      this.showEmail = false;
    }
    if (!this.validateEmail(this.email)) {
      this.showEmail = true;
    }else{
      this.showEmail = false;
    }
    
 

    if (!this.showScale && !this.showDescription && !this.showEmail) {

      if (parseInt(this.scaleCount) < 4) {
        this.scaleCount = this.scaleCount + ' (Not at all likely)';
      } else if (parseInt(this.scaleCount) >= 5 && parseInt(this.scaleCount) < 8) {
        this.scaleCount = this.scaleCount + ' (Netural)';
      } else if (parseInt(this.scaleCount) > 7) {
        this.scaleCount = this.scaleCount + ' (Extremely likely)';
      }

     this.apiService.submitFeedBack(this.scaleCount, this.feedBackDescription, this.email, this.contactPerson).subscribe();

      this.googleAnalyticsFunction('Email/Contact: '+this.email,'Feedback','Feedback',this.feedBackDescription,parseInt(this.scaleCount));
      amplitude.getInstance().logEvent("Feedback",{ "Email/Contact": this.email , "FeedBack Description" : this.feedBackDescription , "Scale Count" : this.scaleCount });

      (document.getElementById('desktopModal') as HTMLInputElement).style.display = 'none';

      (document.getElementById('submitModal') as HTMLInputElement).style.display = 'block';
      
      
      this.resetValues();
    } else {
      (document.getElementById('submitModal') as HTMLInputElement).style.display = 'none';
    }

  }
  selectScore(score: any) {
    console.log('Score : ' + score);
    this.scaleCount = score;
    this.toggle = !this.toggle;
    //console.log(this.toggle);
  }

  getColor(count) {
    switch (count) {
      case 1:
        return '#F0919B';
      case 2:
        return '#F0919B';
      case 3:
        return '#F0919B';
      case 4:
        return '#F0919B';
      case 5:
        return '#049fd9';
      case 6:
        return '#049fd9';
      case 7:
        return '#049fd9';
      case 8:
        return '#82BC5F';
      case 9:
        return '#82BC5F';
      case 10:
        return '#82BC5F';
      default:
        return '';
    }
  }
  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
  resetValues(){
    this.showScale = false;
    this.showDescription = false;
    this.showEmail = false;
    this.scaleCount='';
    this.email = '';
    this.feedBackDescription='';
    this.contactPersmission = true;
    this.contactPerson = 'No';
  }
}
